import React from "react";
import { useSidebarNavigation } from "@/shared/hooks/useSidebarNavigation";
import { SidebarProps } from "@/shared/type/SideMenu.type";

const Sidebar = ({
  sidebarClose,
  setSidebarClose,
  openValue,
  setOpenValue,
}: SidebarProps): React.ReactElement => {
  const {
    menuItems,
    mobileView,
    renderCollapsedMenuItem,
    renderExpandedMenuItem,
  } = useSidebarNavigation({
    sidebarClose,
    openValue,
    setOpenValue,
    setSidebarClose,
  });

  return (
    <aside
      className={`sidebar ${sidebarClose ? "sidebar-close" : "sidebar-open"}`}
    >
      <ul className="space-y-3 md:pl-5 md:pr-2 overflow-x-visible overflow-y-auto pt-5 max-h-[calc(100vh-80px)]">
        {menuItems.map((item, index) => (
          <li key={item.id} className="relative side-link">
            {sidebarClose && !mobileView
              ? renderCollapsedMenuItem(item, index)
              : renderExpandedMenuItem(item, index)}
          </li>
        ))}
      </ul>
    </aside>
  );
};

export default React.memo(Sidebar);
